export const VERSION = '1.5.6'

const API_SERVER = import.meta.env.VITE_API_SERVER || 'https://webdev11.mydevfactory.com/arijeet-das/gemsby/public'

// Relative in development, so requests go through the vite proxy and the session
// cookies are first-party to this page — see the proxy block in vite.config.ts
// for why that is a requirement rather than a convenience.
//
// Still absolute for a build: unlike the marketplace and seller (whose generated
// Netlify _redirects proxy /api/v1/*), the admin deployment serves from nginx and
// nginx.conf has no /api/v1 location. Add one and this can drop to '/api/v1'
// everywhere; until then a deployed admin talks to the API cross-origin and
// cannot read the hint cookie.
export const API_ROOT = import.meta.env.DEV
  ? '/api/v1'
  : `${API_SERVER}/api/v1`
export const API_LOGIN_PATH = 'login'
export const API_INVENTORY_PATH = 'inventory'
export const API_RETAILER_PATH = 'retailer'
export const API_FORGOT_PASSWORD_PATH = 'forgot_password'
export const API_RESET_PASSWORD_PATH = 'reset_password'

export const LIST_PAGE_LENGTH = 20

export const ALGOLIA_INDICES = {
  dev: {
    retailers: 'retailers_dev',
    inventory: 'inventory_dev'
  },
  prod: {
    retailers: 'retailers',
    inventory: 'inventory'
  }
}

export const MAIL_SEND_API_URL = '/v3/mail/send'

export const EMAIL_ADDRESS = 'info@mydiamondapp.com'
export const SUPPORT_EMAIL = 'support@gemsby.com'
// export const PRIVACY_URL = 'http://www.mydiamondrevolution.com/retailers/privacypolicy.html'
// export const TOS_URL = 'http://www.mydiamondrevolution.com/retailers/termsofservice.html'
// export const MAGAZINE_URL = 'https://magazine.mydiamond.io'
// export const HELP_URL = 'https://intercom.help/gemsby'
// export const MISSION_URL = 'http://www.mydiamondrevolution.com'
export const GEMSBY_URL = "https://marketplace-gemsby.mydevfactory.com"
export const PRIVACY_URL = 'https://marketplace-gemsby.mydevfactory.com/privacy-policy'
export const TOS_URL = 'https://marketplace-gemsby.mydevfactory.com/terms-conditions'
export const MAGAZINE_URL = 'https://medium.com/gemsbymagazine'
export const HELP_URL = ''
export const MISSION_URL = ''
export const INSTALL_PAGE_URL = 'https://mydiamond.app.link/app-install-page'

const servers = {
  // development: 'https://app-a01m.gemsby.com',
  // production: 'https://gemsby.com'
  development: 'https://marketplace-gemsby.mydevfactory.com',
  production: 'https://marketplace-gemsby.mydevfactory.com'
}
export const SERVER = servers[process.env.NODE_ENV]

export const OPEN_HOUSE = true

export default {
  VERSION,
  API_ROOT,
  API_LOGIN_PATH,
  API_RETAILER_PATH,
  API_INVENTORY_PATH,
  API_FORGOT_PASSWORD_PATH,
  API_RESET_PASSWORD_PATH,
  ALGOLIA_INDICES,
  MAIL_SEND_API_URL,
  EMAIL_ADDRESS,
  SUPPORT_EMAIL,
  PRIVACY_URL,
  TOS_URL,
  SERVER,
  OPEN_HOUSE
}
